import useStore from "../store.ts";
import {toRaw} from "vue";
import {postTask} from "../worker/DataWorkerManager.ts";
import {getBatchCoordinator} from "../utils/SubscriptionBatchCoordinator.ts";

class SubscriptionManagerImpl {
    public async postDirect(componentId: string): Promise<any> {
        const store = useStore();
        const component = store.components[componentId];
        if (!component) return null;

        const payload = this.buildPayload(componentId);
        try {
            return await postTask(componentId, payload, 'subscription-manager:direct');
        } catch (e) {
            console.warn(`[SubscriptionManager] postDirect failed for ${componentId}:`, e);
            return null;
        }
    }

    public async requestSubscriptionUpdate(
        componentId: string,
        channel: number,
        row: number,
        callback: (data: any, row: number, channel: number, found: boolean, version: number, error?: unknown) => void,
        contextId?: string
    ): Promise<void> {
        const raw = this.buildPayload(componentId);
        const payload = { itemText: raw.itemText, adoptText: raw.adoptText };

        try {
            await getBatchCoordinator().requestSubscriptionUpdate(
                payload,
                (result) => {
                    if (result.ok) {
                        callback(result.data, result.row, result.channel, result.found, result.version);
                        return;
                    }
                    console.warn(`[SubscriptionManager] Detached batch failure for ${componentId}:`, result.error);
                    callback(null, row, channel, false, -1, result.error);
                },
                contextId
            );
        } catch (error) {
            callback(null, row, channel, false, -1, error);
            throw error;
        }
    }

    private buildPayload(componentId: string): any {
        const store = useStore();
        // Read-only: the raw component skips the reactive-proxy cost per field read.
        const component = toRaw(store.components)[componentId];
        return {
            itemID: componentId,
            itemText: component.dynamic.json(),
            adoptText: component.adoptData.size > 0
                ? JSON.stringify(Object.fromEntries(component.adoptData.entries()))
                : "{}",
        };
    }
}

let managerInstance: SubscriptionManagerImpl | null = null;
export function getSubscriptionManager(): SubscriptionManagerImpl {
    if (!managerInstance) managerInstance = new SubscriptionManagerImpl();
    return managerInstance;
}


